var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.625,
    height: 22.011,
    viewBox: "0 0 20.625 22.011",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #1a1818;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5588",
    "data-name": "Rectangle 5588",
    className: "cls-1",
    width: 20.625,
    height: 22.011
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    className: "cls-3",
    d: "M14.027,4.679a7.421,7.421,0,0,0-2.75-.884,7.852,7.852,0,1,0,6.841,9.07,1.258,1.258,0,0,1,1.47-1.141A1.223,1.223,0,0,1,20.6,13.209a10,10,0,0,1-6.978,8.214,9.85,9.85,0,0,1-9.256-1.37A9.919,9.919,0,0,1,.028,12.3a10.045,10.045,0,0,1,3.04-8.092A10.378,10.378,0,0,1,14.848,2.233c.08.038.159.078.239.115.17.079.245.019.215-.16-.033-.2-.081-.4-.114-.6A1.288,1.288,0,0,1,16.123.036a1.225,1.225,0,0,1,1.535,1.037c.269,1.4.507,2.816.725,4.23a1.2,1.2,0,0,1-.973,1.42c-1.466.284-2.94.531-4.416.76a1.257,1.257,0,0,1-.513-2.438A8.589,8.589,0,0,1,13.748,4.8a.4.4,0,0,0,.28-.124",
    transform: "translate(0 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-refresh.31c42a838b7c8428e5f78f8dd42fd24a.svg";